/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Adam (tuannd@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jul 10 2024
 **/

import React from "react";

import { Row } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

import { Avatar } from "@/frameworks/core/components";
import * as S from "../emotion";
import { usePersistUser } from "@/frameworks/core/persistence";

export default React.memo(function UserInfo({ id, date, variant }: { id: string; date: string; variant: ChatUI.Size }) {
	const user = usePersistUser(id);

	return (
		<Row
			gap={8}
			verticalAlign="top"
			horizonAlign={variant === "fullSize" ? "left" : "distribute"}
			css={{ paddingTop: variant === "transparent" ? "0px" : "8px" }}
		>
			<Row verticalAlign="top" gap={10} css={{ marginBottom: "4px" }}>
				<Avatar id={id} kind="people_28" useStatus={false} />
				<Row verticalAlign="center" gap={8}>
					<S.Sender typoSize="Title2" typoColor="neutral_80_100" css={{ paddingLeft: "4px" }}>
						{user?.name}
						{user?.blockedByMe ? _T(" (차단됨)") : null}
					</S.Sender>
					<S.Date typoSize="Body4">{date}</S.Date>
				</Row>
			</Row>
		</Row>
	);
});
